import React from 'react'

export default function TheEnd() {
  return (
    <div>Thanks for playing</div>
  )
}
